import classNames from 'classnames';

import dibsCss from 'dibs-css';

const SHARED_TOAST_PROPS = {
    type: 'basic',
    position: 'bottomLeft',
    showCloseButton: false,
    hideTimeoutBar: true,
    closeAfterTimeout: 4000,
    withCustomBackground: true,
    zIndex: 'aboveOverlay',
    className: classNames(dibsCss.bgGreen900, dibsCss.textWhite),
} as const;

export { SHARED_TOAST_PROPS };
